import {
  Clock, Users, Award, Headphones, Target, Shield, Zap, Layers, Sparkles,
  Building2, HardHat, Landmark, Radio, TreeDeciduous, Cable, Truck,
  MessageSquare, FileSearch, PenTool,
} from 'lucide-react';

export const homeBenefits = [
  { icon: Clock, title: 'Accurate & On-Time', description: 'Exact quality inspections throughout every draft process.' },
  { icon: Headphones, title: 'Top-Notch Support', description: 'Faultless communication from consultation to project completion.' },
  { icon: Award, title: 'Smart & Efficient', description: 'Modern CAD technology with reduced runtime durations.' },
  { icon: Users, title: 'Cost-Effective', description: 'Premier quality drafts at reduced internal costs.' },
];

export const homeTestimonials = [
  {
    quote: "I use LAND DRAFTERS for my surveying needs because their work is accurate, their delivery is timely and their cost is fair. Very simple, LAND DRAFTERS never lets me down.",
    author: "Land Surveying Firm Owner",
    location: "Texas",
  },
  {
    quote: "LAND DRAFTERS' Survey CAD Technicians are fabulous. They seem experienced and well qualified. They are all well trained to achieve accuracy each and every time!",
    author: "Land Surveying Firm Owner",
    location: "Florida",
  },
  {
    quote: "LAND DRAFTERS Drafts are absolute pieces of art! We love it! We're glad we found LAND DRAFTERS.",
    author: "Land Surveying Firm Owner",
    location: "California",
  },
  {
    quote: "I find LAND DRAFTERS to be highly efficient and accurate. I have referred my clients to LAND DRAFTERS for over a decade for their survey needs.",
    author: "Land Surveying Firm Owner",
    location: "Ohio",
  },
];

export const homeStats = [
  { number: '15K+', label: 'Projects Delivered' },
  { number: '150+', label: 'Active Clients' },
  { number: '55+', label: 'Expert Team' },
  { number: '99%', label: 'Client Satisfaction' },
];

export const homeKeyFeatures = [
  { icon: Target, title: 'Survey-Grade Accuracy', desc: 'Sub-centimeter precision with RTK GPS, total stations & laser scanners.', color: 'primary' },
  { icon: Clock, title: '24-48hr Turnaround', desc: 'Fast delivery on standard projects without quality compromise.', color: 'secondary' },
  { icon: Shield, title: 'Licensed Engineers', desc: 'PE & PLS stamped deliverables when your project requires certification.', color: 'primary' },
  { icon: Layers, title: 'Full BIM/CAD Stack', desc: 'AutoCAD, Civil 3D, Revit, Tekla, Navisworks — one vendor, all tools.', color: 'secondary' },
  { icon: Zap, title: 'Rush Available', desc: 'Same-day rush options on critical-path drawings and emergency revisions.', color: 'primary' },
  { icon: Sparkles, title: 'AI-Assisted QC', desc: 'Automated quality control catches errors before they reach your team.', color: 'secondary' },
];

export const homeIndustries = [
  { icon: Building2, title: 'Real Estate & Property', desc: 'Title insurance, transactions, dispute resolution.' },
  { icon: HardHat, title: 'Construction', desc: 'General contractors and subcontractors nationwide.' },
  { icon: PenTool, title: 'Architecture & Engineering', desc: 'AE firms requiring overflow drafting capacity.' },
  { icon: Landmark, title: 'Government & Municipal', desc: 'Public works, planning, zoning, infrastructure.' },
  { icon: TreeDeciduous, title: 'Environmental & Mining', desc: 'Land analysis, conservation, resource extraction.' },
  { icon: Radio, title: 'Telecommunications', desc: 'Cell tower surveys, FAA 7460 documentation.' },
  { icon: Cable, title: 'Oil, Gas & Utilities', desc: 'Pipeline corridors, utility easements, ROW.' },
  { icon: Truck, title: 'Transportation & DOT', desc: 'Highway design, ROW, traffic engineering.' },
];

export const homeProcessSteps = [
  { num: '01', icon: MessageSquare, title: 'Discovery Call', desc: 'Tell us about your project. We listen, scope, and confirm.' },
  { num: '02', icon: FileSearch, title: 'Free Quote in 24hrs', desc: 'Detailed scope, timeline, and transparent pricing — fast.' },
  { num: '03', icon: PenTool, title: 'Drafting Begins', desc: 'Dedicated PM and drafters assigned, milestones locked.' },
  { num: '04', icon: Shield, title: 'QC & PE Review', desc: 'Licensed engineer signs off before any release.' },
  { num: '05', icon: Truck, title: 'Delivery & Revisions', desc: 'Get final files plus unlimited revisions until you approve.' },
];
